const AD_FOX_DICTIONARY = {
    order: 'puid1', // номер по порядку
    alias: 'puid2', // алиас статьи/новости
    pid: 'puid3', //
    ip: 'puid4', // ip юзера
    bi: 'puid5', // название (алиас?) организации
    pm: 'puid6', // признак партнёрского материала, boolean
    serveys: 'puid7', // [] опросники
    vs: 'puid8', // если калькулятор, то алиас продукта, иначе -- page alias - тип страницы/название раздела.
    sravniaffid: 'puid9', // идентификатор аффилиата - инфа из хэзофферса
    bic: 'puid10', // алиас организации
    teg: 'puid11', // [] теги по новостям
    rubrika: 'puid12', // рубрика по новостям
    page_type: 'puid13', // тип страницы = статьи/новости news/article
    subStatus: 'puid14', // [] статус подписки
    auth: 'puid15', // авторизованный ли пользователь, boolean
    // 16???
    utmcsr: 'puid17', // utm-теги source
    utmcmd: 'puid18', // utm-теги medium
    ab_test: 'puid19',
    organizationType: 'puid20', // тип организации
};
const YANDEX = 'yandex';
const COMPANY_ID_YANDEX = 302581;

export { AD_FOX_DICTIONARY, COMPANY_ID_YANDEX, YANDEX };
//# sourceMappingURL=yandex.js.map
